"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StackOrientation;
(function (StackOrientation) {
    /// <summary>
    /// Default value is invalid, do not use it.
    /// </summary>
    StackOrientation[StackOrientation["InvalidValue"] = 0] = "InvalidValue";
    /// <summary>
    /// Put all children in one line under parent, order left-to-right horizontally.
    /// </summary>
    StackOrientation[StackOrientation["SingleRowHorizontal"] = 1] = "SingleRowHorizontal";
    /// <summary>
    /// Put all children in one column under parent, order top-bottom vertically.
    /// </summary>
    StackOrientation[StackOrientation["SingleColumnVertical"] = 2] = "SingleColumnVertical";
})(StackOrientation || (StackOrientation = {}));
exports.default = StackOrientation;
